/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Profile/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import InsurancePaymentAccount from './InsurancePaymentAccount/index'
import No from './No/index'
import PersonPaymentAccount from './PersonPaymentAccount/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Profile({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let payorAccountTypeValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'account_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: payorAccountTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PersonPaymentAccount'}>
<PersonPaymentAccount
  viewPath={`${viewPath}/PersonPaymentAccount`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InsurancePaymentAccount'}>
<InsurancePaymentAccount
  viewPath={`${viewPath}/InsurancePaymentAccount`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}